import React, { ReactNode } from "react";

interface Prop {
  children: ReactNode;
  className?: string;
}

type FormGroupProps = {
  children: React.ReactNode;
  className?: string;
  direction?: "row" | "col"; // default: "col"
};

const FormGroup: React.FC<FormGroupProps> = ({
  children,
  className,
  direction = "col",
}) => {
  return (
    <div
      className={`FormGroup flex ${
        direction === "row" ? "flex-row" : "flex-col sm:flex-row"
      } gap-4 sm:gap-5 mb-4 ${className || ""}`}
    >
      {children}
    </div>
  );
};

export default FormGroup;
